import { atom } from "recoil";

// KPC 스캔 원장 API의 서버 페이지 정보와 페이지네이션 이전 업무별 집계를 공유한다.
export const kpcScanPaginationState = atom({
  key: "kpcScanPaginationState",
  default: {
    totalCount: 0,
    page: 0,
    size: 50,
    summary: {
      generalInboundCount: 0,
      slxPickupCount: 0,
    },
  },
});
